import React from 'react';
import classnames from 'classnames';
import { getTranslationKey } from '../../modules/utils/helpers';

interface Discount {
  first_percent?: number;
  first_percent_monthly?: boolean;
  first_percent_halfYearly?: boolean;
  first_percent_yearly?: boolean;
  first_percent_twoYearly?: boolean;
  first_fixed_monthly?: number;
  first_fixed_halfYearly?: number;
  first_fixed_yearly?: number;
  first_fixed_twoYearly?: number;
  [key: string]: any;
}

interface RenderMonthlyPriceYearlyPlanProps {
  intervall: string;
  discount?: Discount;
  discountedPriceFirst: number;
  price: number;
  currency: string;
}

const renderMonthlyPriceYearlyPlan = ({
  intervall,
  discount,
  discountedPriceFirst,
  price,
  currency
}: RenderMonthlyPriceYearlyPlanProps) =>
  intervall === 'yearly' ? (
    <p className="text-muted mb-4">
      {getTranslationKey('pricingTables.monthlyPrice')
        .replace(
          '{{monthlyPrice}}',
          (discount ? Math.round(discountedPriceFirst * 12) : Math.round(price * 12)).toString()
        )
        .replace('{{currency}}', currency)}
    </p>
  ) : (
    <p className="text-muted mb-4">
      {getTranslationKey('pricingTables.dailyPrice')
        .replace(
          '{{dailyPrice}}',
          discount ? (discountedPriceFirst * 12).toFixed(2) : (price * 12).toFixed(0)
        )
        .replace('{{currency}}', currency)}
    </p>
  );

interface RenderPerMonthOrYearlyProps {
  intervall: string;
}

const renderPerMonthOrYearly = ({ intervall }: RenderPerMonthOrYearlyProps) =>
  intervall === 'yearly' ? (
    <p className="mb-2">{getTranslationKey('pricingTables.perYear')}</p>
  ) : (
    <p className="mb-2">{getTranslationKey('pricingTables.perMonths')}</p>
  );

interface PricingItemTitleProps {
  price: number;
  plan: string;
  currency: string;
  discount?: Discount;
  intervall: string;
  isSB?: boolean;
  noMinimumContractLength?: boolean;
}

const PricingItemTitle: React.FC<PricingItemTitleProps> = ({
  price,
  plan,
  currency,
  discount,
  intervall,
  isSB
}) => {
  if (discount) {
    var discountedPrice = 0; // eslint-disable-line
    var discountedPriceFirst = 0; // eslint-disable-line
    var months: number; // eslint-disable-line

    switch (intervall) {
      case 'halfYearly':
        months = 6;
        break;
      case 'yearly':
        months = 12;
        break;
      case 'twoYearly':
        months = 24;
        break;
      default:
        months = 1;
    }

    if (discount[`first_percent_${intervall}`]) {
      discountedPriceFirst = Math.round(price - price * (discount.first_percent! / 100)); // eslint-disable-line
      discountedPriceFirst = discountedPriceFirst < 0 ? 0 : discountedPriceFirst; // eslint-disable-line
    }

    if (discount[`first_fixed_${intervall}`]) {
      discountedPriceFirst = Math.round( // eslint-disable-line
        (price * months - discount[`first_fixed_${intervall}`]) / months
      );
      discountedPriceFirst = discountedPriceFirst < 0 ? 0 : discountedPriceFirst; // eslint-disable-line
    }

    // if (discountedPrice === 0) discountedPrice = price;
  }

  return (
    <div className="title">
      <h2>
        {isSB
          ? getTranslationKey(`pricingTables.sb_product_name_${plan}_${intervall}`)
          : getTranslationKey(`pricingTables.${plan}`)}
      </h2>
      <h2 className={classnames('mb-2', { discount })}>
        <sup>{currency}</sup>
        {price}
        {!discount && isSB && (
          <p className="mb-2">{getTranslationKey('pricingTables.perMonths')}</p>
        )}
      </h2>

      {!discount && intervall === 'yearly' && (
        <p className="mb-2">{getTranslationKey('pricingTables.yearlySavingsToMonthly')}</p>
      )}
      {!discount &&
        renderMonthlyPriceYearlyPlan({
          intervall,
          discount,
          discountedPriceFirst: discountedPriceFirst!, // eslint-disable-line
          price,
          currency
        })}
      {discount && (
        <div>
          <h2 className="m-b-10">
            <sup>{currency}</sup>
            {/* eslint-disable-next-line */}
            {discountedPriceFirst}
          </h2>
          {isSB && renderPerMonthOrYearly({ intervall })}
          {intervall === 'yearly' && (
            <p className="mb-2">{getTranslationKey('pricingTables.yearlySavingsToMonthly')}</p>
          )}
          {renderMonthlyPriceYearlyPlan({
            intervall,
            discount,
            discountedPriceFirst: discountedPriceFirst!, // eslint-disable-line
            price,
            currency
          })}
          <small>
            <p className="text-muted">
              {getTranslationKey('pricingTables.discountedPriceFirst')}
              <br />
              {getTranslationKey('pricingTables.discountedPriceFollowUps')
                .replace('$$price$$', discountedPrice.toString()) // eslint-disable-line
                .replace('$$currency$$', currency)
                .replace('$$intervall$$', getTranslationKey(`pricingTables.${intervall}`))}
            </p>
          </small>
        </div>
      )}
    </div>
  );
};
export default PricingItemTitle;
